<template>
  <div class="amountOf">
    <div class="completerecords-three-one">
      <span>用户下单时间:</span>
        <span>{{orderTime}}</span>
    </div>
  </div>
</template>
<script>
import { getDetail } from "api/index/api";
export default {
  props: {
    commodityList: {} //数据
  },
  data() {
    return {
        orderTime:null,//用户下单时间
    };
  },
  created(){
   this.getPayment();
  },
  methods: {
        // 详情接口
    getPayment() {
      let params = {
        serialNumber: this.commodityList.serialNumber,
        sellerId: this.commodityList.sellerId,
        status: this.commodityList.status
      };
      getDetail(params).then((res) => {
      // 用户下单时间
      if(res.orderTime != undefined){
           let orderTimeDate = new Date(res.orderTime);
            let YY4 = orderTimeDate.getFullYear() + '-';
            let MM4 = (orderTimeDate.getMonth() + 1 < 10 ? '0' + (orderTimeDate.getMonth() + 1) : orderTimeDate.getMonth() + 1) + '-';
            let DD4 = (orderTimeDate.getDate() < 10 ? '0' + (orderTimeDate.getDate()) : orderTimeDate.getDate());
            let hh4 = (orderTimeDate.getHours() < 10 ? '0' + orderTimeDate.getHours() : orderTimeDate.getHours()) + ':';
            let mm4 = (orderTimeDate.getMinutes() < 10 ? '0' + orderTimeDate.getMinutes() : orderTimeDate.getMinutes()) + ':';
            let ss4 = (orderTimeDate.getSeconds() < 10 ? '0' + orderTimeDate.getSeconds() : orderTimeDate.getSeconds());
            this.orderTime = YY4 + MM4 + DD4 +" "+ hh4 + mm4 + ss4;
      }
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.completerecords-three-one {
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.completerecords-three-one span:nth-child(1) {
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 37px;
}
.completerecords-three-one:nth-child(even) {
  margin: 24px 0;
}
.completerecords-three-one span:nth-child(2) {
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 37px;
}
</style>


// WEBPACK FOOTER //
// src/pages/completeRecords/details/forthe.vue